import { Illustration, Text } from "@clipboard-health/ui-components";
import { Link, Stack } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { Button } from "@src/appV2/redesign/components/Button";
import { SHIFT_DISCOVERY_LIST_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

export function EmptyShiftBlock() {
  const { openArticle } = useZendeskArticle();
  const { shiftBlocksSupportLink } = useSupportLinks();
  return (
    <>
      <Stack spacing={7} alignItems="center" justifyContent="center" flex={1}>
        <Illustration type="block-shift" />
        <Text variant="h4">No blocks at this moment</Text>
        <Link
          onClick={async () => {
            await openArticle(shiftBlocksSupportLink);
          }}
        >
          What is a block of shifts?
        </Link>
        <Button
          variant="outlined"
          size="small"
          href={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`}
        >
          Browse Per Diem Shifts
        </Button>
      </Stack>
      <Stack flex={1} alignItems="center" justifyContent="end" sx={{ pb: 4 }}>
        <Text variant="body1" align="center">
          Want repeat shifts at your favorite workplaces?
        </Text>
        <Text variant="body1" align="center">
          If a nearby workplace wants to activate block shifts, email us their name and information
          at{" "}
          <Link
            href="mailto:productfeedback@clipboardhealth.com"
            sx={{
              color: (theme) => theme.palette.info.main,
            }}
          >
            productfeedback@clipboardhealth.com
          </Link>
        </Text>
      </Stack>
    </>
  );
}
